import React, { FC } from 'react';

import clsx from 'clsx';

import { MenuItemChild } from '@da-g3-acl/shared/common';

import { MenuItemPath } from '../../../types/menuItemPath';
import { ChevronRightIcon } from '../../icons/ChevronRightIcon';
import { DownloadIcon } from '../../icons/DownloadIcon';

import styles from './index.module.scss';

interface MenuItemProps {
	item: MenuItemChild;
	isParentOfSelected: boolean;
	menuPath: MenuItemPath;
	selectedMenuPaths: MenuItemPath[];
	showTag: boolean;
	onClick: (event: React.MouseEvent<HTMLLIElement, MouseEvent>) => void;
}

const MenuItem: FC<MenuItemProps> = ({
	item,
	menuPath,
	isParentOfSelected,
	selectedMenuPaths,
	showTag,
	onClick,
}: MenuItemProps) => {
	const isSelected = selectedMenuPaths.map((path) => JSON.stringify(path)).includes(JSON.stringify(menuPath));

	return (
		<li
			className={clsx(styles.statusMenuItem, {
				[styles.activeItem]: isSelected,
				[styles.isParentOfSelected]: isParentOfSelected,
			})}
			key={`image-type-${item.id}`}
			onClick={(e) => {
				onClick(e);
			}}
		>
			<div className={styles.leftSlot}>
				{item.onDownload && (
					<button
						type="button"
						className={styles.downloadButton}
						title="Download"
						onClick={(e) => {
							e.stopPropagation();
							item.onDownload?.();
						}}
					>
						<DownloadIcon size={16} />
					</button>
				)}
				{showTag && <div className={styles.itemTag}>{item.tag}</div>}
			</div>
			<div className={styles.itemName}>{item.name}</div>
			{(item.children?.length ?? 0) > 0 && (
				<div className={styles.parentIndicator}>
					<ChevronRightIcon size={20} />
				</div>
			)}
		</li>
	);
};

export default MenuItem;
